<template>
    <section
        class="hero section center-content"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container-sm">
            <div
                class="hero-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <div class="hero-content">
                    <h1 class="mt-0 mb-12 reveal-scale-down" data-reveal-delay="300">
                        Get better at guitar, the fun way
                    </h1>
                    <div class="container-xs">
                        <p class="m-0 mb-32 reveal-scale-down" data-reveal-delay="400">
                            Our software makes learning guitar easy– and fun. Sign up and watch the hours pass by. Take our 30-day challenge and see for yourself.
                        </p>
                        <div class="reveal-scale-down" data-reveal-delay="500">
                            <c-button tag="a" color="primary" href="https://cruip.com/" wide-mobile>Pricing and plans</c-button>
                        </div>
                    </div>
                </div>
                <div class="hero-figure illustration-element-01 reveal-scale-down" data-reveal-delay="600">
                    <c-image
                        class="has-shadow"
                        :src="require('@/assets/images/hero-image.png')"
                        alt="Hero"
                        :width="896"
                        :height="502" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CButton from '@/components/elements/Button.vue'
import CImage from '@/components/elements/Image.vue'

export default {
  name: 'CHeroFull',
  mixins: [SectionProps],
  components: {
    CButton,
    CImage
  }
}
</script>